import { useState } from 'react';
import PropTypes from 'prop-types';
import { cn } from '@repo/zolintra-utils';
// Components
import { Avatar } from '../../atoms/Avatar/Avatar';
// Styles
import styles from './Header.module.css';
import { Icon } from '../../atoms/Icon/Icon';

export function Header({
  title, userName, userAvatarUrl, logout, className, onOpenMenu, isMenuOpen,
}) {
  const [isLogoutOpen, setIsLogoutOpen] = useState(false);

  return (
    <header className={cn([styles.nav, className])}>
      <div className={styles.titleRow}>
        {onOpenMenu ? (
          <button
            type="button"
            className={styles.menuButton}
            onClick={onOpenMenu}
            aria-label={isMenuOpen ? 'Fermer le menu' : 'Ouvrir le menu'}
            aria-expanded={isMenuOpen}
          >
            <Icon icon="menu" className={styles.menuIcon} />
          </button>
        ) : null}
        <h1>{title}</h1>
      </div>

      <div className={cn([styles.user])}>
        <button
          type="button"
          className={styles.userButton}
          aria-expanded={isLogoutOpen}
          aria-label={userName}
          onClick={() => setIsLogoutOpen((open) => !open)}
        >
          <Avatar src={userAvatarUrl} title={userName} size="small" />
          <span>{userName}</span>
          <Icon icon="arrowDown" className={styles.arrow} />
        </button>

        {logout ? (
          <div className={cn([styles.logout, isLogoutOpen && styles.logoutOpen])}>
            <button type="button" onClick={logout.handleLogout} className={styles['logout-btn']}>
              {logout.label}
            </button>
          </div>
        ) : null}
      </div>
    </header>
  );
}

Header.propTypes = {
  title: PropTypes.string.isRequired,
  userName: PropTypes.string.isRequired,
  userAvatarUrl: PropTypes.string,
  logout: PropTypes.shape({
    label: PropTypes.string,
    handleLogout: PropTypes.func,
  }),
  className: PropTypes.string,
  onOpenMenu: PropTypes.func,
  isMenuOpen: PropTypes.bool,
};

Header.defaultProps = {
  userAvatarUrl: '',
  className: null,
  logout: null,
  onOpenMenu: undefined,
  isMenuOpen: false,
};

export default Header;
